import { render, staticRenderFns } from "./posProductChoice.vue?vue&type=template&id=6998b00b&scoped=true&"
import script from "./posProductChoice.vue?vue&type=script&lang=js&"
export * from "./posProductChoice.vue?vue&type=script&lang=js&"
import style0 from "./posProductChoice.vue?vue&type=style&index=0&id=6998b00b&prod&lang=css&"
import style1 from "./posProductChoice.vue?vue&type=style&index=1&id=6998b00b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6998b00b",
  null
  
)

export default component.exports